import { PolicyActivityResponse } from '@clearcover/core-app-types';
import {
  AnimatedScreen,
  Card,
  ExpansionPanel,
  PageNumberPaginate,
} from 'Shared/components';
import React, { FC, useState } from 'react';

import { useNewApi } from 'Shared/services/Api';
import { useParams } from 'react-router-dom';
import {
  PolicyActivityExpansionContents,
  PolicyActivityExpansionHeader,
} from './Accordion';
import { PolicyActivityErrorBoundary } from './PolicyActivityErrorBoundary';
import styles from './styles.module.css';

const DEFAULT_PAGE_SIZE = 10;

export const PolicyActivities: FC<{}> = () => {
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const { id: policyId } = useParams<{
    id: string;
  }>();

  const [{ data, loading, error, refetch: fetchActivities }] =
    useNewApi<PolicyActivityResponse>(
      {
        url: `/policies/${policyId}/activities?size=${pageSize}&page=${pageNumber}`,
      },
      true,
      false
    );

  if (error || !data?.showActivities) return null;
  return (
    <PolicyActivityErrorBoundary>
      <Card
        id="policy-activities-card"
        title="Activities"
        className={styles.activitiesCard}
      >
        <AnimatedScreen loading={loading}>
          <div className={styles.activitiesList}>
            {data.activities.map((activity, index) => (
              <ExpansionPanel
                data-testid={`activity-${index}`}
                key={`${activity.id}`}
                head={
                  <PolicyActivityExpansionHeader
                    activity={activity}
                    data-testid={`activity-${index}-expansion-header`}
                  />
                }
              >
                <PolicyActivityExpansionContents
                  activity={activity}
                  data-testid={`activity-${index}-expansion-contents`}
                />
              </ExpansionPanel>
            ))}
          </div>
        </AnimatedScreen>
        <PageNumberPaginate
          limit={pageSize}
          total={data.pagination.total}
          pageNumber={pageNumber}
          onPageChange={(pageNumber) => {
            setPageNumber(pageNumber - 1);
            fetchActivities();
          }}
          onLimitChange={setPageSize}
        />
      </Card>
    </PolicyActivityErrorBoundary>
  );
};
